import angular from 'angular';

import BlndTable from 'app/common/table';
import editModalTpl from './templates/edit.modal.html';


class BaseConfigurationModal {

    constructor (Config, $uibModalInstance) {
        "ngInject";
        this.$modal = $uibModalInstance;
        this.Config = Config;
        this.fieldsForType = Config.$config.product_configuraton.fields;
        this.data = {
            type: Config.$config.product_configuraton.types[0][0],
        };
    }

    showField (name) {
        return this.fieldsForType[this.data.type].includes(name);
    }

    close () {
        this.$modal.dismiss();
    }

    submit () {
        this.close();
    }

}


class AddConfigurationModal extends BaseConfigurationModal {

    constructor (Config, $uibModalInstance, $state, $stateParams, $growl, ProductConfStore) {
        "ngInject";
        super(Config, $uibModalInstance);

        this.$state = $state;
        this.$growl = $growl;
        this.ProductConfStore = ProductConfStore;
        this.data = {
            company: {
                id: $stateParams.companyId,
            },
            type: Config.$config.product_configuraton.types[0][0],
        };
    }

    get title () {
        return `Add Product Configuration`;
    }

    submit () {
        let self = this;

        self.ProductConfStore.create(this.data).then(
            function(data){
                self.ProductConfStore.get(data.id).then(function(data){
                    self.$growl.added();
                    self.$modal.close(data);
                });
            },
            function(resp) {
                self.errors = resp.data;
            },
        ).finally(() => self.loading = false);
    }
}


class EditConfigurationModal extends BaseConfigurationModal {

    constructor (Config, R, $uibModalInstance, object) {
        "ngInject";

        super(Config, $uibModalInstance);
        this.object = object;
        this.R = R;
        this.data = this.R.copy(this.object);
    }

    get title () {
        return `Edit ${this.object.name} configuration`;
    }

    submit () {
        let self = this;
        this.data.put().then(
            function(data){
                angular.extend(self.object, data);
                self.$modal.close();
            },
            function(resp) {
                self.errors = resp.data;
            },
        ).finally(() => self.loading = false);
    }
}

export class ProductsCtrl {
    constructor (NgTableParams, $rootScope, $state, $growl, Modal,
                 $company, ProductConfStore) {
        "ngInject";

        var self = this;
        this.Modal = Modal;
        this.company = $company;
        this.$growl = $growl;
        this.$state = $state;
        this.params = {
            ordering: ['material_sequence'],
        };
        this.store = ProductConfStore;
        this.store.init();

        $rootScope.$watch('selectedObject', function (newValue) {
            self.selectedObject = newValue;
        });

        // Filter configurations by company ID;

        this.params.company = this.company.id;

        this.table = new BlndTable(NgTableParams, this.store, {defaultParams: this.params});
    }

    selectRow (objectId) {
        this.selectedObject = objectId;
        this.$state.go('r.in.top.admin.company.productconf.list.product', {objectId: objectId});
    }

    refresh () {
        return this.table.refresh(this.params);
    }

    addModal () {
        let self = this;
        let $modal = this.Modal.open({
            template: editModalTpl,
            controller: AddConfigurationModal,
        });

        $modal.result.then(function(obj){
            self.$growl.added();
            self.store.list.unshift(obj);
            self.selectRow(obj.id);
        });
    }
}


export class ProductCtrl {
    constructor ($rootScope, $state, Modal, $growl, Config, $object, $company) {
        "ngInject";
        this.object = $object;
        this.company = $company;
        this.$growl = $growl;
        this.$state = $state;
        this.Modal = Modal;
        this.fieldsForType = Config.$config.product_configuraton.fields;

        $rootScope.object = this.object;
    }


    showField (name) {
        return this.fieldsForType[this.object.type].includes(name);
    }

    editModal () {
        let self = this;
        let $modal = this.Modal.open({
            template: editModalTpl,
            controller: EditConfigurationModal,
            resolve: {
                object: () => this.object,
            },
        });

        $modal.result.then(function(){
            self.$growl.updated();
        });
    }

    deleteModal () {
        let self = this;
        let $modal = self.Modal.openConfirm({
            confirmName: 'Yes',
            text: `Are you sure you want to delete product configuration?`,
        });

        $modal.wait.then(function() {
            $modal.close();
            self.object.remove().then(() => {
                self.$state.go('r.in.top.admin.company.productconf.list', {}, {reload: true});
                self.$growl.success('Product Configuration deleted');
            })
            .finally(() => {
                self.loading = false;
            });
        });
    }
}


export class NotesCtrl {
    constructor ($object, $company) {
        "ngInject";
        this.object = $object;
        this.company = $company;
    }
}


export class LogCtrl {
    constructor ($object, $company) {
        "ngInject";
        this.object = $object;
        this.company = $company;
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/product_conf/ctrls.js